<template>
	<div class="chat-panel-history-item">
		<virtual-list class="list-infinite scroll-touch" v-if="lists.length > 0"
		  :data-key="type == 'im'?'msg_id':'msgId'"
		  :data-sources="lists"
		  :data-component="itemComponent"
		  :extra-props="{
				senderType:senderType,
				
			}"
		  :item-class="'list-item-infinite'"
		  v-on:totop="onScrollToTop"
		>
			<div class="chat-panel-history-item__loading" slot="header">
				<span v-show="loading" class="color-blue">
					<i class="el-icon-loading" /> 正在加载数据中...
				</span>
				<span v-if="status == 1 && !loading" class="pointer color-blue" @click="toMore">
					<i class="el-icon-bottom" /> 查看更多消息...
				</span>
				<span v-show="status == 2 && !loading"> 没有更多消息了... </span>
			</div>
		</virtual-list>
		<el-empty description="暂无数据" v-else></el-empty>
	</div>
</template>

<script>
	// import chatPanelItem from '@/views/im-channel/im/chat-panel-item.vue'
	import chatPanelItem from '@/views/im-channel/imService/panels/chatItem.vue';
	import { getSort, getMutipSort } from '@/utils/functions'
	export default {
		props: {
		  apiUrl: { 
		    //required: true,//请求apiurl
			default:'livechat/msg/list'
		  },
		  type:{
			  default:'im' //默认IM聊天历史记录
		  },
		  responseType:{
			default:'list'  //接口响应返回的数据字段
		  },
		  customerId:{
			  default:'' //用户id
		  },
		  sessionId:{
			  // required:true //会话id
		  },
		  active:{
			  default:1 // 针对im历史聊天切换机器人与人工监听数据变化
		  },
		  senderType:{
			  default:'sender_type' //接口返回发送人类型字段 有的接口不统一
		  }
		},
		watch:{
			'sessionId':{
				handler(val) {
					this.$nextTick(()=>{
						this.lists = [];
						this.listQuery.pageNum = 1
						this.loadChatRecords(this.apiUrl)
					})
				},
			},
			'active':{
				handler(val){
					this.lists = [];
					this.listQuery.pageNum = 1
					this.loadChatRecords(this.apiUrl)
				}
			}
		},
		data(){
			return {
				loading:false,
				status:1,//1 查看更多 2没有更多
				lists:[],
				listQuery:{
					pageNum:1,
					pageSize:10,
				},
				totalSize:0,
				itemComponent: chatPanelItem,
			}
		},
		methods:{
			loadChatRecords(url){
				if(this.type == 'im') {
					this.listQuery.sessionId = this.sessionId;
					this.listQuery.customerId = this.customerId;
				}
				this.loading = true
				this.$api.getImHistoryLists(url,this.listQuery).then(res => {
					if(res.errcode == 0) {
						this.loading = false
						let key = this.responseType;
						let results = res[key].length > 0 ?  this.lists.concat(res[key]) : res[key];
						this.status = res.pages > this.listQuery.pageNum ? 1 : 2
						this.lists = results.sort(getMutipSort([
						  getSort((a, b) => a.sendtime < b.sendtime),
						]))
						this.totalSize = res.pages;
					}
				})
			},
			toMore(){
				this.listQuery.pageNum++
				if(this.listQuery.pageNum > this.totalSize) {
					this.status = 2
					this.listQuery.pageNum = 1
				}else {
					this.status = 1
				}
				this.loadChatRecords(this.apiUrl)
			},
			onScrollToTop(){
				if (this.status == 1) {
					this.toMore()
				}
			},
			onLoadData(url){
				this.lists = [];
				this.listQuery.pageNum = 1;
				this.loadChatRecords(url);
			}
		},
		mounted() {
			this.loadChatRecords(this.apiUrl)
		}
	}
</script>

<style lang="scss" scoped>
	.chat-panel-history-item {
		height: 100%;
		overflow:hidden;
		padding: 20px ;
		.scroll-touch {
			height: 100%;
			overflow-y: auto;
			&::-webkit-scrollbar {
			  display: none;
			}
		}
		
				
		&::-webkit-scrollbar-thumb {
		  border-radius: 3px;
		  background-color: #c0bebc;
		}
		&__loading {
			height: 30px;
			line-height: 30px;
			margin: 5px 0;
			text-align: center;
			user-select: none;
			font-size: 13px;
			color: #cec4c4;
						
			.color-blue {
				color: #409eff;
			}
		}
	}
</style>
